import { render, staticRenderFns } from "./SquareWithIcon.vue?vue&type=template&id=211e5d25"
import script from "./SquareWithIcon.vue?vue&type=script&lang=js"
export * from "./SquareWithIcon.vue?vue&type=script&lang=js"
import style0 from "./SquareWithIcon.vue?vue&type=style&index=0&id=211e5d25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports